"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const base_models_1 = require("@integration/base-models");
const GetDefaultPropositionsResponseProductDetailsElectricityRates_1 = tslib_1.__importDefault(require("./GetDefaultPropositionsResponseProductDetailsElectricityRates"));
const GetDefaultPropositionsResponseProductDetailsGasRates_1 = tslib_1.__importDefault(require("./GetDefaultPropositionsResponseProductDetailsGasRates"));
const GetDefaultPropositionsResponseProductDetailsFitTariffs_1 = tslib_1.__importDefault(require("./GetDefaultPropositionsResponseProductDetailsFitTariffs"));
class GetDefaultPropositionsResponseProductDetails extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 'G_H_B', description: 'Product key' }),
    tslib_1.__metadata("design:type", String)
], GetDefaultPropositionsResponseProductDetails.prototype, "productKey", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 60.0, description: 'Annual connection fee excl. VAT.' }),
    tslib_1.__metadata("design:type", Number)
], GetDefaultPropositionsResponseProductDetails.prototype, "connectionFeeAnnual", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => GetDefaultPropositionsResponseProductDetailsElectricityRates_1.default),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    tslib_1.__metadata("design:type", GetDefaultPropositionsResponseProductDetailsElectricityRates_1.default)
], GetDefaultPropositionsResponseProductDetails.prototype, "ratesElectricity", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => GetDefaultPropositionsResponseProductDetailsGasRates_1.default),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    tslib_1.__metadata("design:type", GetDefaultPropositionsResponseProductDetailsGasRates_1.default)
], GetDefaultPropositionsResponseProductDetails.prototype, "ratesGas", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => GetDefaultPropositionsResponseProductDetailsFitTariffs_1.default),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    tslib_1.__metadata("design:type", Array)
], GetDefaultPropositionsResponseProductDetails.prototype, "feedInTariffs", void 0);
exports.default = GetDefaultPropositionsResponseProductDetails;
